'use strict';

/**
 * This generates css and js that will be loaded on all pages
 */
 import { Collapse } from 'bootstrap'

import '../css/main.scss';
import LoginField from "./LoginField/LoginField";
import NewsletterFormHandler from "./Newsletter/NewsletterFormHandler";
import Footer from "./Footer/Footer";

window.super = () => {
    new LoginField();
    new NewsletterFormHandler();
    new Footer();
};
